(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5188],{

/***/ 71412:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giftcode",
      function () {
        return __webpack_require__(90859);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ CardGiftcode; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
// EXTERNAL MODULE: ./app/context/PackageContext.tsx
var PackageContext = __webpack_require__(61983);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/img/store/tag.png
/* harmony default export */ var tag = ({"src":"/_next/static/media/tag.61da9bdf.png","height":23,"width":25,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAuElEQVR42nWOMarCUBREz817yY/g+4lCwB24CjurvyI3YPGXINi7AfdiYRetJKjEyoT7rhFrBwaGYWCOtOv1zVRLYjSSRFAFM4aMpOndW9eVbj6HvhecI16vJJMJdB16OpXe+t6GIkqWRUYjcbMZEgJa16CKT8djicej08fDJUWB5Dn2fH5usgx/bhp+23YfiuKgl0uO6pvlbT8MGnbL5Wa7WPzxRb6qqv+p6hSgXq1+yhCiAQIY2AvazUuB2Usv+wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/img/store/fire.png
/* harmony default export */ var fire = ({"src":"/_next/static/media/fire.664cdaa7.png","height":22,"width":19,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAA6UlEQVR42h3OvUrDYBQG4Peck0iNSWmMtZbEFrX4iyBUBHFVOnkDLg7u3oM4iojgqHgfLoKjk5ujgxgcjJZISfqT7xQ6P8tDSXtLABTmv7dObJ5g9ALAA1xHCACSRhm8W7jU3Yk1y2ZQ0gaAL6vbOYgwZbWk0jyjJnma5yjevv0Jklc+lyA4kZCrdsfF8FlS/C35OvhYZKnN74vTD63lWGTDhczF01LLX1Cp3zE7mkiYQVYiAwlgHe4xz/bAXilipO837BdKm0e22muGqtsidQGP0vvJ1lzhGO3Ta1pYbenP5695fbwEcDsG5r1GP7laNIUAAAAASUVORK5CYII=","blurWidth":7,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
// EXTERNAL MODULE: ./app/hooks/useGAEventsTracker.ts
var useGAEventsTracker = __webpack_require__(64800);
;// CONCATENATED MODULE: ./app/components/card-giftcode/index.tsx










const CardGiftcode = (param)=>{
    let { item , redirect  } = param;
    const { themeApp , setVisibleGiftcodeDetail , setSelectedGiftcode  } = (0,react.useContext)(context/* AppContext */.Il);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { setVisible , visible , setDataSelected  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const random = item.total_giftcode - item.total_received > 0 ? item.total_giftcode - item.total_received : 1;
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Giftcode");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        onClick: ()=>{
            if (redirect === "store") {
                GAEventsTracker("Store_giftcode_get_now");
            } else {
                GAEventsTracker("Giftcode_get_now");
            }
            setVisibleGiftcodeDetail(true);
            setSelectedGiftcode(item);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-[120px] overflow-hidden cursor-pointer flex rounded-[14px] w-full bg-white dark:bg-white/10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-[14px] flex items-center py-[10px] border  border-r-0 rounded-tl-[14px] rounded-bl-[14px] border-black/10 dark:border-white/10 relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: item === null || item === void 0 ? void 0 : item.giftcode_description,
                            src: item === null || item === void 0 ? void 0 : item.game_icon,
                            width: 72,
                            height: 72,
                            className: "rounded-[10px]"
                        }),
                        (item === null || item === void 0 ? void 0 : item.type) === "newbie" && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: tag,
                            width: 25,
                            height: 23,
                            alt: "tag",
                            className: "absolute left-[11px] top-[18px]"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[1px] h-full border border-dashed border-giftcode relative border-black/10 dark:border-neutral-08",
                    "data-activeid": themeApp === "dark" ? "#ffffff1a" : "#0000001A"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col border border-l-0 flex-1 rounded-tr-[14px] rounded-br-[14px] px-[14px] py-[10px] border-black/10 dark:border-white/10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "line-clamp-2 text-[14px] Nunito-600 leading-[19px] pb-[2px]",
                            title: item === null || item === void 0 ? void 0 : item.title,
                            children: item === null || item === void 0 ? void 0 : item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "line-clamp-1 text-neutral-06 dark:text-neutral-07 text-[12px] leading-[16px]",
                            children: item === null || item === void 0 ? void 0 : item.game_name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between gap-[8px] mt-auto mb-0 relative",
                            children: [
                                (item === null || item === void 0 ? void 0 : item.type) === "newbie" && (item === null || item === void 0 ? void 0 : item.total_giftcode) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: fire,
                                    alt: "fire",
                                    style: {
                                        zIndex: 2
                                    },
                                    className: "absolute top-[2px] left-[-6px]"
                                }),
                                (item === null || item === void 0 ? void 0 : item.type) === "newbie" && (item === null || item === void 0 ? void 0 : item.total_giftcode) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex-1 w-full h-[16px] rounded-[16px] bg-[#EB737366] flex items-center justify-end xs:justify-center pr-3 xs:pr-0 relative overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                zIndex: 1,
                                                width: "".concat((random === (item === null || item === void 0 ? void 0 : item.total_giftcode) ? 0 : random) * 100 / (item === null || item === void 0 ? void 0 : item.total_giftcode), "%"),
                                                background: "linear-gradient(90deg, #F64A46 0%, #F5AA92 100%)"
                                            },
                                            className: "absolute left-0 top-0 h-full rounded-tl-[16px] rounded-bl-[16px]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            style: {
                                                zIndex: 2
                                            },
                                            className: "text-[10px] text-white uppercase Nunito-700",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                                i18nKey: t("common.gc_remain", {
                                                    number: random
                                                })
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-neutral-06 dark:text-neutral-07 text-[12px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                        i18nKey: t("common.gc_received", {
                                            number: item === null || item === void 0 ? void 0 : item.total_received
                                        }),
                                        components: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "Nunito-700"
                                            }, 0)
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "main",
                                    className: "text-[12px] Nunito-500 h-[28px] ".concat(item.type === "newbie" ? "w-[83px]" : "px-[16px]", " rounded-[10px]"),
                                    onClick: ()=>{
                                        setVisibleGiftcodeDetail(true);
                                        setSelectedGiftcode(item);
                                    },
                                    children: t("giftcode.get_now")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }, "".concat(item === null || item === void 0 ? void 0 : item.id, "-game-detail-giftcode"));
};


/***/ }),

/***/ 76912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var app_context_AppContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95513);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93378);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55784);




const HeaderCustomMobile = (param)=>{
    let { isInpage , heading , action , customIcon , customAction  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { themeApp  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(app_context_AppContext__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .I);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "md:hidden flex fixed top-0 left-0 w-full z-[50] bg-white dark:bg-bg-header h-[60px] sm:h-[70px] items-center gap-2 justify-between px-5",
            children: !isInpage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "Nunito-700 text-[24px] dark:text-white-color",
                children: heading
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex gap-2 items-center w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        onClick: action,
                        className: "bg-bg-button dark:bg-white/10 rounded-[12px] p-[4px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            width: "24",
                            height: "25",
                            viewBox: "0 0 24 25",
                            fill: "none",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M14 7.5L10 12.5L14 17.5",
                                stroke: themeApp === "dark" ? "#FFFFFF" : "#100D28",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "Nunito-700 text-[16px] dark:text-main-white flex-1 text-center",
                        children: heading
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "cursor-pointer",
                        onClick: customAction,
                        children: customIcon
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderCustomMobile);


/***/ }),

/***/ 90859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ giftcode; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./app/components/header-custom-mb/index.tsx
var header_custom_mb = __webpack_require__(76912);
// EXTERNAL MODULE: ./app/components/card-giftcode/index.tsx + 2 modules
var card_giftcode = __webpack_require__(13053);
// EXTERNAL MODULE: ./app/components/data-empty/index.tsx + 1 modules
var data_empty = __webpack_require__(98269);
// EXTERNAL MODULE: ./app/components/ui/select.tsx + 3 modules
var ui_select = __webpack_require__(80522);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./app/hooks/useGAEventsTracker.ts
var useGAEventsTracker = __webpack_require__(64800);
// EXTERNAL MODULE: ./app/services/query-fn/game/index.ts + 1 modules
var query_fn_game = __webpack_require__(82190);
// EXTERNAL MODULE: ./app/services/query-fn/giftcode/giftcode-query.ts
var giftcode_query = __webpack_require__(32674);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./app/containers/giftcode/AllGiftcode.tsx












const HEADER_HEIGHT = 84;
const AllGiftcode = ()=>{
    var _router_query, _router_query1, _router_query_game_id, _ref;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const [game, setGame] = (0,react.useState)({
        game_name: t("common.all"),
        game_id: "all",
        icon: ""
    });
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Giftcode");
    const giftcodeRef = (0,react.useRef)(null);
    const { data: listGame  } = (0,query_fn_game/* useQueryGetListGame */.Bu)({
        category: "",
        type: "",
        limit: 100,
        page: 1
    });
    const { data , isSuccess , isLoading  } = (0,giftcode_query/* useQueryGetListGiftcode */.Bp)({
        style_list: configs/* GC_TYPE.BY_GAME */.yf.BY_GAME,
        game_id: (router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.game_id) === "all" ? "" : (router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : (_router_query_game_id = _router_query1.game_id) === null || _router_query_game_id === void 0 ? void 0 : _router_query_game_id.toString()) || ""
    });
    const OptionGame = !!listGame ? listGame : [];
    (0,react.useEffect)(()=>{
        if (router.query.game_id && router.query.game_id !== "all") {
            const _game = OptionGame === null || OptionGame === void 0 ? void 0 : OptionGame.find((item)=>{
                return (item === null || item === void 0 ? void 0 : item.game_id) === router.query.game_id;
            });
            if (_game === null || _game === void 0 ? void 0 : _game.game_id) {
                setGame(_game);
            }
        // else {
        //   setGame({ game_name: t("common.all"), game_id: "all", icon: "" })
        //   router.push({
        //     pathname: router.pathname,
        //     query: {
        //       game_id: "all"
        //     }
        //   })
        // }
        } else {
            setGame({
                game_name: t("common.all"),
                game_id: "all",
                icon: ""
            });
        }
    }, [
        OptionGame,
        router,
        router.query.game_id,
        t
    ]);
    const onChangeGame = (value)=>{
        GAEventsTracker("Giftcode_filter_game");
        router.replace({
            pathname: router.pathname,
            query: {
                game_id: value
            }
        });
    };
    (0,react.useEffect)(()=>{
        let timeout = null;
        if (router.query.type === "game" && isSuccess && !isLoading && giftcodeRef && giftcodeRef.current) {
            timeout = setTimeout(()=>{
                if (giftcodeRef.current) {
                    const element = giftcodeRef.current;
                    const offset = HEADER_HEIGHT;
                    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - offset;
                    giftcodeRef.current.style.marginBottom = "250px";
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }
            }, 500);
        }
        return ()=>{
            if (timeout !== null) {
                clearTimeout(timeout);
            }
        };
    }, [
        router,
        isSuccess,
        isLoading,
        giftcodeRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-[20px] md:mt-[32px]",
        ref: giftcodeRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center pb-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "Nunito-700 text-[16px]",
                        children: t("common.all")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                            value: (game === null || game === void 0 ? void 0 : game.game_id) || "all",
                            onValueChange: (value)=>onChangeGame(value),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* SelectTrigger */.i4, {
                                        asChild: false,
                                        className: "px-[8px] h-[28px] border-main-01 dark:bg-main-disable rounded-[8px] bg-bg-disable dark:bg-bg-disable/10 flex gap-[4px] items-center text-main-01 dark:text-main-disable text-[12px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                                placeholder: t("common.chose_game"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex-1",
                                                    children: (game === null || game === void 0 ? void 0 : game.game_name) || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                width: "20",
                                                height: "20",
                                                viewBox: "0 0 20 20",
                                                fill: "none",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M5.8335 8.3335L10.0002 11.6668L14.1668 8.3335",
                                                    stroke: "#7673E6",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                    align: "end",
                                    className: "p-1 rounded-[16px]",
                                    children: OptionGame && ((_ref = [
                                        {
                                            game_name: t("common.all"),
                                            game_id: "all",
                                            icon: ""
                                        },
                                        ...OptionGame.sort((a, b)=>a.game_name.localeCompare(b.game_name))
                                    ]) === null || _ref === void 0 ? void 0 : _ref.map((item)=>{
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                            value: item === null || item === void 0 ? void 0 : item.game_id,
                                            className: "p-[6px] h-[36px] rounded-[12px] hover:!bg-bg-disable hover:!text-main-01 Nunito-500 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center gap-[6px]",
                                                title: item === null || item === void 0 ? void 0 : item.game_name,
                                                children: [
                                                    (item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: item === null || item === void 0 ? void 0 : item.icon,
                                                        alt: item === null || item === void 0 ? void 0 : item.game_name,
                                                        className: "w-[24px] h-[24px] rounded-[6px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "flex-1 line-clamp-1",
                                                        children: item === null || item === void 0 ? void 0 : item.game_name
                                                    })
                                                ]
                                            })
                                        }, item === null || item === void 0 ? void 0 : item.game_id);
                                    }))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid md:grid-cols-2 lg:grid-cols-3 gap-[12px]",
                children: data === null || data === void 0 ? void 0 : data.map((item)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card_giftcode/* CardGiftcode */.K, {
                        item: item
                    }, "".concat(item === null || item === void 0 ? void 0 : item.id, "-all-giftcode"));
                })
            }),
            (data === null || data === void 0 ? void 0 : data.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[80px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconArrowLeft.tsx
var IconArrowLeft = __webpack_require__(82341);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconArrowRight.tsx
var IconArrowRight = __webpack_require__(99777);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
;// CONCATENATED MODULE: ./app/containers/giftcode/ForYouGiftcode.tsx










swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Navigation */.W_
]);
const ForYouGiftcode = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const navigationPrevRef = (0,react.useRef)(null);
    const navigationNextRef = (0,react.useRef)(null);
    const { data  } = (0,giftcode_query/* useQueryGetListGiftcode */.Bp)({
        style_list: configs/* GC_TYPE.FOR_YOU */.yf.FOR_YOU
    });
    return data && (data === null || data === void 0 ? void 0 : data.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-[20px] md:mt-[60px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center pb-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "Nunito-700 text-[16px]",
                        children: t("giftcode.for_you")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hidden lg:flex items-center gap-[6px] ml-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "p-[2px] rounded-[8px] border border-main-01 cursor-pointer",
                                ref: navigationPrevRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowLeft/* IconArrowLeft */.D, {
                                    className: "xs:w-[16px] xs:h-[16px] w-[20px] h-[20px]"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "p-[2px] rounded-[8px] border border-main-01 cursor-pointer",
                                ref: navigationNextRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowRight/* IconArrowRight */.E, {
                                    className: "xs:w-[16px] xs:h-[16px] w-[20px] h-[20px]"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "overflow-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden-scroll-bar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        navigation: {
                            prevEl: navigationPrevRef.current && navigationPrevRef.current,
                            nextEl: navigationNextRef.current && navigationNextRef.current
                        },
                        onInit: (swiper)=>{
                            swiper.params.navigation.prevEl = navigationPrevRef.current;
                            swiper.params.navigation.nextEl = navigationNextRef.current;
                            swiper.navigation.enable();
                            swiper.navigation.update();
                        },
                        breakpoints: {
                            "1140": {
                                spaceBetween: 12,
                                slidesPerView: 3
                            },
                            "768": {
                                spaceBetween: 12,
                                slidesPerView: 2
                            },
                            "576": {
                                spaceBetween: 12,
                                slidesPerView: 1.5
                            }
                        },
                        slidesPerView: "auto",
                        spaceBetween: 8,
                        className: "w-full gap-[8px]",
                        children: data === null || data === void 0 ? void 0 : data.map((item)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: "xs:max-w-[320px] w-fit h-full flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_giftcode/* CardGiftcode */.K, {
                                    item: item
                                })
                            }, "".concat(item === null || item === void 0 ? void 0 : item.id, "-for-you"));
                        })
                    })
                })
            })
        ]
    }) : null;
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconReceivedGiftcode.tsx


const IconReceivedGiftcode = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.49984 17.5C3.65889 17.5 2.1665 16.0076 2.1665 14.1667V13.3333C2.1665 12.8731 2.54984 12.5136 2.98475 12.363C3.96362 12.0241 4.6665 11.0941 4.6665 10C4.6665 8.90585 3.96362 7.97588 2.98475 7.63698C2.54984 7.4864 2.1665 7.1269 2.1665 6.66667V5.83333C2.1665 3.99238 3.65889 2.5 5.49984 2.5H15.4998C17.3408 2.5 18.8332 3.99238 18.8332 5.83333V6.66667C18.8332 7.1269 18.4498 7.4864 18.0149 7.63698C17.0361 7.97588 16.3332 8.90585 16.3332 10C16.3332 11.0941 17.0361 12.0241 18.0149 12.363C18.4498 12.5136 18.8332 12.8731 18.8332 13.3333V14.1667C18.8332 16.0076 17.3408 17.5 15.4998 17.5H5.49984ZM7.99984 8.33333C8.46007 8.33333 8.83317 7.96024 8.83317 7.5C8.83317 7.03976 8.46007 6.66667 7.99984 6.66667C7.5396 6.66667 7.1665 7.03976 7.1665 7.5C7.1665 7.96024 7.5396 8.33333 7.99984 8.33333ZM13.8332 12.5C13.8332 12.9602 13.4601 13.3333 12.9998 13.3333C12.5396 13.3333 12.1665 12.9602 12.1665 12.5C12.1665 12.0398 12.5396 11.6667 12.9998 11.6667C13.4601 11.6667 13.8332 12.0398 13.8332 12.5ZM13.4418 7.94194C13.6859 7.69786 13.6859 7.30214 13.4418 7.05806C13.1977 6.81398 12.802 6.81398 12.5579 7.05806L7.5579 12.0581C7.31382 12.3021 7.31382 12.6979 7.5579 12.9419C7.80197 13.186 8.1977 13.186 8.44178 12.9419L13.4418 7.94194Z",
            fill: "#7673E6"
        })
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconUseGiftcode.tsx


const IconUseGiftcode = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "19",
        height: "18",
        viewBox: "0 0 19 18",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.7915 8.99984C1.7915 4.74264 5.24264 1.2915 9.49984 1.2915C12.0213 1.2915 14.26 2.50152 15.6674 4.3752C15.807 4.56103 16.0381 4.65406 16.2675 4.61672C16.4969 4.57938 16.6866 4.41785 16.7601 4.19735L17.5928 1.69735C17.7019 1.36986 17.5248 1.01595 17.1973 0.906867C16.8699 0.797784 16.516 0.974837 16.4069 1.30233L15.9229 2.75522C14.2959 1.08208 12.0193 0.0415039 9.49984 0.0415039C4.55229 0.0415039 0.541504 4.05229 0.541504 8.99984C0.541504 9.34502 0.821326 9.62484 1.1665 9.62484C1.51168 9.62484 1.7915 9.34502 1.7915 8.99984ZM18.4582 8.99984C18.4582 8.65466 18.1783 8.37484 17.8332 8.37484C17.488 8.37484 17.2082 8.65466 17.2082 8.99984C17.2082 13.257 13.757 16.7082 9.49984 16.7082C6.97835 16.7082 4.73967 15.4982 3.33229 13.6245C3.19271 13.4387 2.96155 13.3456 2.73216 13.383C2.50277 13.4203 2.31304 13.5818 2.23959 13.8023L1.40687 16.3023C1.29778 16.6298 1.47484 16.9837 1.80233 17.0928C2.12981 17.2019 2.48372 17.0248 2.59281 16.6973L3.07675 15.2445C4.70379 16.9176 6.98036 17.9582 9.49984 17.9582C14.4474 17.9582 18.4582 13.9474 18.4582 8.99984ZM5.33333 6.5C5.33333 5.57953 6.07953 4.83333 7 4.83333H12C12.9205 4.83333 13.6667 5.57953 13.6667 6.5V11.5C13.6667 12.4205 12.9205 13.1667 12 13.1667H7C6.07953 13.1667 5.33333 12.4205 5.33333 11.5V6.5ZM10.9582 7.33317C10.9582 7.67835 10.6783 7.95817 10.3332 7.95817H8.6665C8.32133 7.95817 8.0415 7.67835 8.0415 7.33317C8.0415 6.98799 8.32133 6.70817 8.6665 6.70817H10.3332C10.6783 6.70817 10.9582 6.98799 10.9582 7.33317Z",
            fill: "#7673E6"
        })
    });
};

// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
;// CONCATENATED MODULE: ./app/containers/giftcode/GiftcodeBanner.tsx








const GiftcodeBanner = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { visibleGiftcodeDetail , setVisibleGiftcodeDetail , selectedGiftcode , setSelectedGiftcode , setVisibleUseGiftcode  } = (0,react.useContext)(context/* AppContext */.Il);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Giftcode");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "giftcode-banner md:h-[98px] relative md:flex items-center w-full justify-center relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "hidden md:block text-white text-[32px] Nunito-800 text-center text-transparent mb-[25px]",
                children: "Giftcode"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden absolute md:flex items-center left-[50%] bottom-[-28px] md:translate-x-[-50%] p-[8px] bg-white dark:bg-dark-mode-box-2 rounded-[24px] shadow-[4px_4px_15px_0_rgba(0,0,0,0.04)] w-[360px] h-[56px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 h-full cursor-pointer flex items-center justify-center text-[14px] Nunito-600 text-main-01 gap-[6px] active:opacity-60",
                        onClick: ()=>{
                            setVisibleUseGiftcode(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconUseGiftcode, {}),
                            t("giftcode.use_giftcode")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[1px] h-[20px] bg-black/10 dark:bg-white/10"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 h-full cursor-pointer flex items-center justify-center text-[14px] Nunito-600 text-main-01 gap-[6px] active:opacity-60",
                        onClick: ()=>{
                            router.push("/reward-center?item=giftcode");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconReceivedGiftcode, {}),
                            t("giftcode.received_giftcode")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex md:hidden gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 flex items-center justify-center bg-white dark:bg-white/10 rounded-[12px] h-[36px] text-[12px] Nunito-600 text-main-01 gap-[6px] active:opacity-60 shadow-[4px_4px_15px_0_rgba(0,0,0,0.04)]",
                        onClick: ()=>{
                            setVisibleUseGiftcode(true);
                            GAEventsTracker("Giftcode_use");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconUseGiftcode, {}),
                            t("giftcode.use_giftcode")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 flex items-center justify-center bg-white dark:bg-white/10 rounded-[12px] h-[36px] text-[12px] Nunito-600 text-main-01 gap-[6px] active:opacity-60 shadow-[4px_4px_15px_0_rgba(0,0,0,0.04)]",
                        onClick: ()=>{
                            router.push("/reward-center?item=giftcode");
                            GAEventsTracker("Giftcode_redeemed");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconReceivedGiftcode, {}),
                            t("giftcode.received_giftcode")
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/giftcode/HotGiftcode.tsx










swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Navigation */.W_
]);
const HotGiftcode = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const navigationPrevRef = (0,react.useRef)(null);
    const navigationNextRef = (0,react.useRef)(null);
    const { data  } = (0,giftcode_query/* useQueryGetListGiftcode */.Bp)({
        style_list: configs/* GC_TYPE.IS_HOT */.yf.IS_HOT
    });
    return data && (data === null || data === void 0 ? void 0 : data.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-[20px] md:mt-[32px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center pb-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "Nunito-700 text-[16px] flex items-center gap-2 text-[#EB7373]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                        opacity: "0.4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M17 4V9.5H7V4C7 2.89543 7.89543 2 9 2H15C16.1046 2 17 2.89543 17 4Z",
                                            fill: "#EB7373"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M12 22C16.4183 22 20 18.4183 20 14C20 9.58172 16.4183 6 12 6C7.58172 6 4 9.58172 4 14C4 18.4183 7.58172 22 12 22ZM13.3432 11.6805L12.7869 10.5086C12.465 9.83048 11.535 9.83048 11.2131 10.5086L10.6568 11.6805C10.529 11.9497 10.282 12.1364 9.99615 12.1796L8.75226 12.3675C8.03253 12.4762 7.74515 13.3958 8.26595 13.9236L9.16603 14.8358C9.37284 15.0454 9.46722 15.3474 9.4184 15.6434L9.20591 16.9314C9.08297 17.6767 9.83536 18.2451 10.4791 17.8932L11.5917 17.285C11.8473 17.1453 12.1527 17.1453 12.4083 17.285L13.5209 17.8932C14.1646 18.2451 14.917 17.6767 14.7941 16.9314L14.5816 15.6434C14.5328 15.3474 14.6272 15.0454 14.834 14.8358L15.7341 13.9236C16.2549 13.3958 15.9675 12.4762 15.2477 12.3675L14.0038 12.1796C13.718 12.1364 13.471 11.9497 13.3432 11.6805Z",
                                        fill: "#EB7373"
                                    })
                                ]
                            }),
                            t("giftcode.most_used")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hidden lg:flex items-center gap-[6px] ml-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "p-[2px] rounded-[8px] border border-main-01 cursor-pointer",
                                ref: navigationPrevRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowLeft/* IconArrowLeft */.D, {
                                    className: "xs:w-[16px] xs:h-[16px] w-[20px] h-[20px]"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "p-[2px] rounded-[8px] border border-main-01 cursor-pointer",
                                ref: navigationNextRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowRight/* IconArrowRight */.E, {
                                    className: "xs:w-[16px] xs:h-[16px] w-[20px] h-[20px]"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "overflow-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden-scroll-bar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        navigation: {
                            prevEl: navigationPrevRef.current && navigationPrevRef.current,
                            nextEl: navigationNextRef.current && navigationNextRef.current
                        },
                        onInit: (swiper)=>{
                            swiper.params.navigation.prevEl = navigationPrevRef.current;
                            swiper.params.navigation.nextEl = navigationNextRef.current;
                            swiper.navigation.enable();
                            swiper.navigation.update();
                        },
                        breakpoints: {
                            "1140": {
                                spaceBetween: 12,
                                slidesPerView: 3
                            },
                            "768": {
                                spaceBetween: 12,
                                slidesPerView: 2
                            },
                            "576": {
                                spaceBetween: 12,
                                slidesPerView: 1.5
                            }
                        },
                        slidesPerView: "auto",
                        spaceBetween: 8,
                        className: "w-full gap-[8px]",
                        children: data === null || data === void 0 ? void 0 : data.map((item)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: "xs:max-w-[320px] w-fit h-full flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_giftcode/* CardGiftcode */.K, {
                                    item: item
                                })
                            }, "".concat(item === null || item === void 0 ? void 0 : item.id, "-for-you"));
                        })
                    })
                })
            })
        ]
    }) : null;
};

;// CONCATENATED MODULE: ./app/containers/giftcode/index.tsx







const GiftcodeContainer = ()=>{
    const router = (0,next_router.useRouter)();
    const onClose = ()=>{
        router.push("/store").then();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "md:mt-[40px] max-w-[1062px] mx-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_custom_mb/* default */.Z, {
                isInpage: true,
                heading: "Giftcode",
                action: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftcodeBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForYouGiftcode, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HotGiftcode, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AllGiftcode, {})
        ]
    });
};

;// CONCATENATED MODULE: ./pages/giftcode/index.tsx



const Giftcode = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftcodeContainer, {})
    });
};
var __N_SSP = true;
/* harmony default export */ var giftcode = ((0,esm/* withTranslation */.Zh)("common")(Giftcode));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2888,179], function() { return __webpack_exec__(71412); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);